import { render, staticRenderFns } from "./fraud-errors.vue?vue&type=template&id=0b8e5b94&scoped=true&"
import script from "./fraud-errors.vue?vue&type=script&lang=js&"
export * from "./fraud-errors.vue?vue&type=script&lang=js&"
import style0 from "./fraud-errors.vue?vue&type=style&index=0&id=0b8e5b94&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8e5b94",
  null
  
)

export default component.exports